(() => {
  if (customElements.get('ala-delivery')) return;
  const localDay = now => {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const value = type => Number(parts.find(p => p.type === type).value);
    return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
  };
  const key = date => date.toISOString().slice(0, 10);
  const addDays = (date, days, skipWeekends, closed) => {
    const result = new Date(date);
    for (let remaining = days; remaining > 0;) {
      result.setUTCDate(result.getUTCDate() + 1);
      if ((!skipWeekends || ![0, 6].includes(result.getUTCDay())) && !closed.has(key(result))) remaining--;
    }
    return result;
  };
  const label = date => {
    const opts = {timeZone:'UTC'};
    const month = new Intl.DateTimeFormat('tr-TR', {...opts, month:'long'}).format(date);
    const weekday = new Intl.DateTimeFormat('tr-TR', {...opts, weekday:'long'}).format(date);
    const title = s => s.charAt(0).toLocaleUpperCase('tr-TR') + s.slice(1);
    return `${date.getUTCDate()} ${title(month)} ${title(weekday)}`;
  };
  class AlaDelivery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.refresh = () => {
        const root = this.closest('.ap');
        const button = root?.querySelector('.ap-submit');
        if (root?.querySelector('[data-variant]')?.value === '52629977137516' || button?.disabled) { this.hidden = true; return; }
        const now = new Date();
        const today = localDay(now);
        const hour = Number(new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Istanbul',hour:'2-digit',hourCycle:'h23'}).format(now));
        const closed = new Set((this.dataset.closed || '').split(/[\s,;]+/).filter(v => /^\d{4}-\d{2}-\d{2}$/.test(v)));
        const weekend = this.dataset.weekends !== 'false';
        const cutoff = Number(this.dataset.cutoff || 16);
        const workingToday = (!weekend || ![0,6].includes(today.getUTCDay())) && !closed.has(key(today));
        const ready = workingToday && hour < cutoff ? today : addDays(today,1,weekend,closed);
        const dispatch = addDays(ready, Math.max(0, Number(this.dataset.dispatch) || 0), weekend, closed);
        const transit = Math.max(1, Number(this.dataset.transit) || 1);
        const arrival = addDays(dispatch,transit,weekend,closed);
        const arrivalEnd = addDays(dispatch,transit+1,weekend,closed);
        for (const [name, date] of [['order',today],['dispatch',dispatch],['arrival',arrival]]) {
          const target = this.querySelector(`[data-delivery-${name}]`);
          target.dateTime = key(date);
          target.textContent = name === 'arrival' ? `${transit}–${transit+1} ${weekend ? 'iş günü' : 'gün'}` : name === 'order' || key(date) === key(today) ? 'Bugün' : label(date);
          if (name === 'arrival') target.title = `${label(arrival)} – ${label(arrivalEnd)} · Kargodan sonra`;
        }
        this.hidden = false;
      };
      const options = {signal:this.controller.signal};
      this.closest('.ap')?.querySelector('[data-variant]')?.addEventListener('change',this.refresh,options);
      window.addEventListener('pageshow',this.refresh,options);
      this.refresh();
      this.timer = setInterval(this.refresh,60000);
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); }
  }
  customElements.define('ala-delivery',AlaDelivery);
})();
